import { render, staticRenderFns } from "./AddressModal.vue?vue&type=template&id=2dc1951b"
import script from "./AddressModal.vue?vue&type=script&lang=js"
export * from "./AddressModal.vue?vue&type=script&lang=js"
import style0 from "./AddressModal.vue?vue&type=style&index=0&id=2dc1951b&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports